import axiosClient from "../../http-common";
import { TENANTS_BASE_URL } from "../../constants/routes/api";

class TenantsApiService {
  
  getUserRoleForTenant = async (tenantId, userId) => {
    return await axiosClient.get(`${TENANTS_BASE_URL}/${tenantId}/users/${userId}/role`);
  }

  getUsersOfTenant = async (tenantId) => {
    return await axiosClient.get(`${TENANTS_BASE_URL}/${tenantId}/users`);
  };

  updateUserRolesForTenant = async (tenantId, userId, roles) => {
    let body = {
      data: {
        roles: roles,
      },
    };
    return await axiosClient.put(`${TENANTS_BASE_URL}/${tenantId}/users/${userId}/role`, body);
  }

  addUserToTenant = async (tenantId, user) => {
    let body = {
      data: user,
    };
    return await axiosClient.post(`${TENANTS_BASE_URL}/${tenantId}/users`, body);
  }

  deleteUserFromTenant = async (tenantId, userId) => {
    return await axiosClient.delete(`${TENANTS_BASE_URL}/${tenantId}/Users/${userId}`);
  }

  getAllTenantUsers = async (tenantId) => {
    return await axiosClient.get(`${TENANTS_BASE_URL}/${tenantId}/Users`);
  }

  getAccessiblePrinterTemplatesByTenantId = async (tenantId) => {
    return await axiosClient.get(`${TENANTS_BASE_URL}/${tenantId}/LabelPrinterTemplates`);
  }

  updateContainer = async (tenantId, containerId, updateContainerRequest) => {
    var payload = JSON.stringify(updateContainerRequest);
    return await axiosClient.put(`${TENANTS_BASE_URL}/${tenantId}/containers/${containerId}`, payload);
  }
}

export default new TenantsApiService();